import React, { useEffect, useState } from "react";
import {
    CheckboxIcon,
    CrossIcon,
    StyledLabel,
    StyledTextInput,
} from "@aureskonnect/react-ui";
import { useTranslation } from "react-i18next";
import { AvForm, AvGroup } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import { useSnapshot } from "valtio";
import classnames from "classnames";
import { uuid } from "uuidv4";

import {
    store as appStore,
    setActions,
    setIsActionsClicked,
    setIsEdited,
} from "../store";
import { store as userStore } from "@components/VerticalLayout/store";
import { setSelectedRow } from "@pages/SettingGeneral/Language/store";

import { ipMatchWord } from "@constants/index";
import {
    CustomCardHeader,
    CustomCardBody,
    CustomCardFooter,
} from "@components/Common/CustomCardStyled";
import { ConfirmationEditMessage } from "@components/Common/ConfirmationEditMessage";
import ErrorToast from "@components/Common/ErrorTost";
import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";
import { checkIpIfExist } from "@helpers/general";
import { useFetchGlobal } from "../../../../../api/hooks";

type applicationConfigurationType = {
    setIsAddApplication: Function;
    setDataIsUpdated: Function;
    isAddApplication: boolean;
    isAddNewApplicationButtonClicked: boolean;
    selectedRows: any;
    data: any;
    setIsConsult: Function;
    isConsult: boolean;
    shopIds: any;
};

export function AddApplication({
    setIsAddApplication,
    isAddApplication,
    setDataIsUpdated,
    isAddNewApplicationButtonClicked,
    selectedRows,
    data,
    setIsConsult,
    isConsult,
    shopIds,
}: applicationConfigurationType) {
    const { t } = useTranslation();
    const { fetchGlobal } = useFetchGlobal();
    const {
        oneShop,
        userID,
        franchiseID,
        shopID,
        operatorID,
        resourceIp,
    } = useSnapshot(userStore);
    const { isEdited, isPlusIconClicked, isActionsClicked } = useSnapshot(
        appStore
    );
    const [inputDesignation, setInputDesignation] = React.useState<boolean>(
        false
    );
    const [
        isValidateButtonClicked,
        setIsValidateButtonClicked,
    ] = React.useState<boolean>(true);
    const [isModalOpened, setIsModalOpened] = React.useState<boolean>(false);
    const [designation, setDesignation] = useState<string>("");
    const [remark, setRemark] = useState<string>("");
    const [title, setTitle] = useState<string>("");
    const [ip, setIp] = useState<string>("");
    const [isApplicationListExist, setIsApplicationListExist] = React.useState<
        boolean
    >(false);
    const [ipExist, setIpExist] = React.useState<boolean>(false);
    const [localNamesApplications, setLocalNamesApplications] = useState<
        string[]
    >([]);
    const uuidUser = localStorage.getItem("uuidUser");

    const isExist = React.useCallback(() => {
        let localNamesApplication: any[] = [];
        data?.othersData?.listDesignation !== undefined &&
            data.othersData.listDesignation.length !== 0 &&
            data.othersData.listDesignation.forEach((elt: any) => {
                if (selectedRows[0]?.appId === undefined) {
                    if (!oneShop && elt.shopId === selectedRows[0]?.shopId) {
                        localNamesApplication.push(
                            elt["Application"].toUpperCase()
                        );
                    } else if (oneShop) {
                        localNamesApplication.push(elt.toUpperCase());
                    }
                } else {
                    if (
                        !oneShop &&
                        elt.shopId === selectedRows[0]?.shopId &&
                        elt["Application"].toUpperCase() !==
                            selectedRows[0][t("Application")].toUpperCase()
                    ) {
                        localNamesApplication.push(
                            elt["Application"].toUpperCase()
                        );
                    } else if (
                        oneShop &&
                        elt.toUpperCase() !==
                            selectedRows[0][t("Application")].toUpperCase()
                    ) {
                        localNamesApplication.push(elt.toUpperCase());
                    }
                }
            });
        setLocalNamesApplications(localNamesApplication);
    }, [data.othersData.listDesignation, selectedRows, oneShop, t]);

    const matchWordDesignation = new RegExp(
        new RegExp(/^[\w]+([-_\s]{1}[A-Za-z0-9]+)*$/i)
    );

    async function addApplication() {
        let id = uuid();
        const apiUrlAdd = `${process.env.REACT_APP_API_V2_URL}/settings/application/orb`;
        setIsValidateButtonClicked(false);
        const appId: string = "ORB";
        let arrayOfIds = oneShop ? [shopID] : shopIds;
        let results: any = [];

        if (arrayOfIds?.length > 0) {
            arrayOfIds.forEach(async (element: any) => {
                let data = {
                    userId: userID,
                    shopId: element,
                    franchiseId: franchiseID,
                    type: "Add",
                    operatorId: operatorID,
                    uuidUser: uuidUser,
                    data: {
                        [appId]: {
                            id_application: appId,
                            data_app: {
                                [id]: {
                                    id_application_children: id,
                                    template: {},
                                    designation: designation,
                                    ip: ip,
                                    note: remark,
                                    isArchived: false,
                                },
                            },
                        },
                    },
                };
                try {
                    const result: any = await fetchGlobal(apiUrlAdd, {
                        headers: {
                            "Content-Type": "application/json",
                        },
                        body: JSON.stringify(data),
                        method: "POST",
                    });
                    if (result.error) {
                        results.push("false");
                    } else {
                        results.push("true");
                    }
                } catch (e) {
                    toast.error(`${t("There's an error")!}`, {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 2000,
                        theme: "colored",
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                    });
                }
            });
        }

        if (results.some((element: any) => element === "false")) {
            toast.error("Error while saving selection!");
        } else {
            toast.success(`${t("The application was successfully added")!}`, {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
                theme: "colored",
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                icon: <CheckboxIcon height={25} width={25} fill="white" />,
            });
            setDesignation("");
            setRemark("");
            setIp("");
            setIsValidateButtonClicked(true);
            setDataIsUpdated!(true);
            setIsEdited(false);
        }
    }

    async function editApplication() {
        setIsValidateButtonClicked(false);
        const apiUrlAdd = `${process.env.REACT_APP_API_V2_URL}/settings/application/orb`;
        const appId: string = "ORB";
        let data = {
            userId: userID,
            shopId: oneShop ? shopID : selectedRows[0]?.shopId,
            franchiseId: franchiseID,
            operatorId: operatorID,
            uuidUser: uuidUser,
            data: {
                [appId]: {
                    id_application: appId,
                    data_app: {
                        [selectedRows[0]?.appId]: {
                            id_application_children: selectedRows[0]?.appId,
                            printer: selectedRows[0].printer,
                            designation: designation,
                            ip: ip,
                            note: remark,
                            isArchived: false,
                            template: selectedRows[0].template,
                        },
                    },
                },
            },
        };
        try {
            const result: any = await fetchGlobal(apiUrlAdd, {
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(data),
                method: "POST",
            });
            if (result.error) {
                throw Error("error");
            }
            toast.success(`${t("The application was successfully changed")!}`, {
                position: toast.POSITION.TOP_CENTER,
                theme: "colored",
                icon: <CheckboxIcon height={25} width={25} fill="white" />,
            });
            setDesignation("");
            setRemark("");
            setIp("");
            setDataIsUpdated!(true);
            setIsValidateButtonClicked(true);
            setIsAddApplication!(!isAddApplication);
            setIsEdited(false);
        } catch (e) {
            toast.error(`${t("There's an error")!}`, {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 2000,
                theme: "colored",
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
            });
        }
    }

    useEffect(() => {
        if (selectedRows[0]?.appId) {
            setTitle(
                t(isConsult ? "View an application" : "Modify an application")
            );
            setDesignation(selectedRows[0][t("Application")]);
            setRemark(selectedRows[0][t("Remark")]);
            setIp(selectedRows[0][t("Address IP")]);
        } else {
            setTitle(t("Add an application"));
            setDesignation("");
            setRemark("");
            setIp("");

            setInputDesignation(false);
            setIsApplicationListExist(false);
            setIsValidateButtonClicked(true);
            // setExist(false);
        }

        // eslint-disable-next-line
    }, [selectedRows, t, isAddNewApplicationButtonClicked, isAddApplication]);
    React.useEffect(() => {
        isExist();
    }, [data, designation, isExist, oneShop]);

    React.useEffect(() => {
        if (isPlusIconClicked) {
            setInputDesignation(false);
            setIsApplicationListExist(false);
        }
    }, [isPlusIconClicked]);
    useEffect(() => {
        if (Object.values(selectedRows).length !== 0) {
            if (selectedRows[t("Application")] !== "") {
                setInputDesignation(false);
            }
        }
        setIsValidateButtonClicked(true);
        // eslint-disable-next-line
    }, [selectedRows]);
    let shopId: string = oneShop
        ? shopID
        : selectedRows[0] !== undefined
        ? selectedRows[0].shopId
        : "";
    React.useEffect(() => {
        let check: any = checkIpIfExist(
            resourceIp,
            ip,
            selectedRows[0] !== undefined &&
                selectedRows[0][t("Designation")] !== undefined
                ? selectedRows[0][t("Designation")]
                : "",
            shopId
        );

        setIpExist(check && selectedRows[0][t("Address IP")] !== ip);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ip, selectedRows, shopId]);

    return (
        <React.Fragment>
            <AvForm className="card">
                <CustomCardHeader
                    className="d-flex align-items-center justify-content-between"
                    style={{ maxHeight: "76px" }}
                >
                    <h5 className="pt-3">{title}</h5>
                    <CrossIcon
                        style={{ cursor: "pointer" }}
                        height={13}
                        width={13}
                        onClick={() => {
                            setIsConsult(false);
                            setIsAddApplication!(!isAddApplication);
                            setIsValidateButtonClicked(true);
                            setDataIsUpdated!(true);
                        }}
                    />
                </CustomCardHeader>
                <CustomCardBody
                    className={`pl-3 pr-5 ${isConsult ? "pe-none__clz" : ""}`}
                >
                    <AvGroup>
                        <StyledLabel
                            htmlFor="name"
                            className="required__clz mt-3"
                        >
                            {t("Designation")}
                        </StyledLabel>
                        <StyledTextInput
                            autocomplete="off"
                            className={classnames("orb_inp_designation", {
                                input__clz:
                                    inputDesignation ||
                                    isApplicationListExist ||
                                    (designation.trim() === "" &&
                                        designation !== ""),
                            })}
                            id="designation"
                            name="designation"
                            placeholder={t("Write")}
                            type="text"
                            onChange={(e: any) => {
                                if (
                                    localNamesApplications.includes(
                                        e.target.value.trim().toUpperCase()
                                    )
                                ) {
                                    setIsApplicationListExist(true);
                                } else {
                                    setIsApplicationListExist(false);
                                }
                                setDesignation(e.target.value);
                                setIsEdited!(true);
                                setIsValidateButtonClicked(true);
                                setInputDesignation(false);
                            }}
                            value={designation}
                            validate={{
                                pattern: {
                                    value: matchWordDesignation,
                                    errorMessage: t("Prohibited characters"),
                                },
                            }}
                            autoFocus={isConsult ? false : true}
                        />
                        {inputDesignation ||
                        (designation.trim() === "" && designation !== "") ? (
                            <div
                                style={{
                                    width: "100%",
                                    marginTop: "0.25rem",
                                    fontSize: "80%",
                                    color: "#f46a6a",
                                }}
                            >
                                {t("Please enter a designation")}
                            </div>
                        ) : null}
                        {isApplicationListExist ? (
                            <div
                                style={{
                                    width: "100%",
                                    marginTop: "0.25rem",
                                    fontSize: "80%",
                                    color: "#f46a6a",
                                }}
                            >
                                {t("The name is already exists")!}
                            </div>
                        ) : null}
                    </AvGroup>

                    <AvGroup>
                        <StyledLabel htmlFor="example-input" className="mt-3">
                            {t("IP address")}
                        </StyledLabel>
                        <StyledTextInput
                            id="ip"
                            name="ip"
                            autocomplete="off"
                            placeholder={t("Write")}
                            type="text"
                            onChange={(e: any) => {
                                setIsValidateButtonClicked(true);
                                setIp(e !== null ? e.target.value : "");
                                setIsEdited!(true);
                            }}
                            className={classnames("orb_inp_ipAddress", {
                                input__clz:
                                    (ip !== undefined &&
                                        !ip.match(ipMatchWord) &&
                                        ip !== "") ||
                                    ipExist,
                            })}
                            value={ip}
                        />

                        {ip !== undefined &&
                            !ip.match(ipMatchWord) &&
                            ip !== "" && (
                                <div
                                    style={{
                                        width: "100%",
                                        marginTop: "0.25rem",
                                        fontSize: "80%",
                                        color: "#f46a6a",
                                    }}
                                >
                                    {t("IP address is invalid")!}
                                </div>
                            )}
                        {ipExist ? (
                            <div
                                style={{
                                    width: "100%",
                                    marginTop: "0.25rem",
                                    fontSize: "80%",
                                    color: "#f46a6a",
                                }}
                            >
                                {t("The ip address is already exists")!}
                            </div>
                        ) : null}
                    </AvGroup>
                    <AvGroup>
                        <StyledLabel className="mt-3" htmlFor="remark">
                            {t("Remark")}
                        </StyledLabel>
                        <StyledTextInput
                            autocomplete="off"
                            id="remark"
                            name="remark"
                            placeholder={t("Write")}
                            type="text"
                            onChange={(e: any) => {
                                setIsValidateButtonClicked(true);
                                setRemark(e.target.value);
                                if (setIsEdited !== undefined)
                                    setIsEdited!(true);
                            }}
                            value={remark}
                            className="orb_inp_remark"
                        />
                    </AvGroup>
                </CustomCardBody>
                <CustomCardFooter className="pt-1 pb-2">
                    <CustomSecondaryColorButton
                        outline
                        rounded
                        variant="light"
                        className="mr-2 orb_btn_FRcancel"
                        onClick={() => {
                            setIsConsult(false);
                            if (isEdited === true) {
                                setIsActionsClicked(!isActionsClicked);
                                setActions(() => {
                                    setIsEdited(false);
                                    setIsAddApplication!(!isAddApplication);
                                    setDataIsUpdated!(true);
                                });
                            } else {
                                setIsAddApplication!(!isAddApplication);
                                setDataIsUpdated!(true);
                            }
                        }}
                    >
                        <span> {t("Cancel")}</span>
                    </CustomSecondaryColorButton>
                    <CustomMainColorButton
                        rounded
                        disabled={!isValidateButtonClicked}
                        variant="primary"
                        onClick={() => {
                            if (designation === "") setInputDesignation(true);
                            if (
                                !isEdited ||
                                ((selectedRows[0] !== undefined &&
                                    selectedRows[0][t("Application")]) ===
                                    designation &&
                                    selectedRows[0] !== undefined &&
                                    selectedRows[0] !== undefined &&
                                    selectedRows[0][t("Note")] === remark &&
                                    selectedRows[0] !== undefined &&
                                    selectedRows[0][t("Address IP")] === ip)
                            ) {
                                setIsModalOpened(true);
                            } else if (
                                designation.length !== 0 &&
                                designation.trim() !== "" &&
                                designation.match(matchWordDesignation) &&
                                !isApplicationListExist &&
                                !oneShop &&
                                (ip.match(ipMatchWord) || ip === "")
                            ) {
                                if (selectedRows.length === 0) {
                                    ErrorToast(
                                        `${t(
                                            "Attention ! you must select a store."
                                        )!}`
                                    );
                                } else if (
                                    selectedRows[0] !== undefined &&
                                    selectedRows[0].appId === undefined
                                ) {
                                    addApplication();
                                } else if (
                                    selectedRows[0] !== undefined &&
                                    selectedRows[0].appId !== undefined
                                ) {
                                    editApplication();
                                }
                            } else if (
                                designation.length !== 0 &&
                                designation.trim() !== "" &&
                                designation.match(matchWordDesignation) &&
                                !isApplicationListExist &&
                                oneShop &&
                                selectedRows[0] === undefined &&
                                (ip.match(ipMatchWord) || ip === "")
                            ) {
                                addApplication();
                            } else if (
                                designation.length !== 0 &&
                                designation.trim() !== "" &&
                                designation.match(matchWordDesignation) &&
                                !isApplicationListExist &&
                                selectedRows[0] !== undefined &&
                                selectedRows[0].appId !== undefined &&
                                oneShop &&
                                (ip.match(ipMatchWord) || ip === "")
                            ) {
                                editApplication();
                            }
                        }}
                        className={classnames("orb_btn_FRvalidate", {
                            "not-allowed-icon__clz": isConsult,
                        })}
                    >
                        {t("Validate")}
                    </CustomMainColorButton>
                </CustomCardFooter>
            </AvForm>
            <ConfirmationEditMessage
                setDataIsUpdated={setDataIsUpdated}
                isModalOpened={isModalOpened}
                setIsModalOpened={setIsModalOpened}
                isAddClicked={isAddApplication}
                setIsAddClicked={setIsAddApplication}
                setEditedData={setSelectedRow}
            />
        </React.Fragment>
    );
}
